// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EServicesOrchestratorServicePublicNewPathModelsTripleCheckPatientAddressModel } from './eServicesOrchestratorServicePublicNewPathModelsTripleCheckPatientAddressModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EServicesOrchestratorServicePublicNewPathModelsTripleCheckPatientModel {
    'address'?: EServicesOrchestratorServicePublicNewPathModelsTripleCheckPatientAddressModel | null;
    /**
    * @description Gets or sets the gender.
    */
    'gender'?: string | null;
    /**
    * @description Gets or sets the phone.
    */
    'phone'?: string | null;
    /**
    * @description Gets or sets the date of birth.
    */
    'dateOfBirth'?: string | null;
    /**
    * @description Gets or sets the first name.
    */
    'firstName'?: string | null;
    /**
    * @description Gets or sets the last name.
    */
    'lastName'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EServicesOrchestratorServicePublicNewPathModelsTripleCheckPatientModel>> = [
        {
            "name":     "address",
            "baseName": "address",
            "type":     "EServicesOrchestratorServicePublicNewPathModelsTripleCheckPatientAddressModel"
        },
        {
            "name":     "gender",
            "baseName": "gender",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
        {
            "name":     "dateOfBirth",
            "baseName": "dateOfBirth",
            "type":     "string"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return EServicesOrchestratorServicePublicNewPathModelsTripleCheckPatientModel.attributeTypeMap;
    }
}
